import { useI18n } from '@/shared/i18n'

/** Dynamic nav keys are data, not template-authored copy; keep their one translation seam here. */
export function useNavLabels(): { labelOf: (key?: string, label?: string) => string } {
  const { t } = useI18n()
  return {
    labelOf: (key, label) => label ?? (key ? t(key) : ''),
  }
}
